import React from 'react';
import PropTypes from 'prop-types';
import {domToReact} from 'html-react-parser';
import {RenderHTML} from '@learningblocks/storybook-components';
import cName from './style.module.scss';

const TYPE = 'tag';
const NAME = 'p';
/**
 * Question
 *    -Component accepts the HTML question text and render it to HTML
 */

export function Question(props) {
  const replace = (node) => {
    if (node.type === TYPE && node.name === NAME) {
      const className = `${cName.question} ${props.className}`;
      return (
        <p tabIndex={props.tabIndex} className={className}>
          {domToReact(node.children)}
        </p>
      );
    }
  };

  return <RenderHTML content={props.text} replace={replace} />;
}

Question.propTypes = {
  /**
   * Text to be  displayed as question
   * Expects a string p tag
   */
  text: PropTypes.string.isRequired,
  /**
   * ClassName to set on the tag
   */
  className: PropTypes.string,
};

Question.defaultProps = {
  text: '',
  className: '',
};
